import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useClient } from '@context/presentation';
import { sendDimensions } from '@hooks/useRefDimensions';
import { VIEWPORTS, ANALYTICS_EVENTS, PING_INTERVALS, PresentationType, BROWSER_STORAGE_KEYS } from '@constants';
import { useMutation } from 'react-query';
import { updateAnalytics } from '@services/analytics';
import { createAnalyticsEventBody } from '@utils/analytics';
import { getBrowserStorageItem } from '@utils/browserStorage';

const ClientView = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 10px;
    width: 100%;
    top: 0;
    ${props => props.mobile && (
        `@media screen and (orientation: landscape) {
            width: 100%;
        }`
    )};
`;

export const PresentationView = ({ children, slideRef, dispatch, slideState }) => {
    const { leadId } = useClient();
    const { viewport, presentationType } = slideState;
    const { mobile } = VIEWPORTS;
    const { DOCUMENTS_PRESENTATION } = PresentationType;
    const isMobile = viewport === mobile;
    const connectionAnalytics = useMutation(analyticsData => updateAnalytics(analyticsData));

    // Regardless of the presentation type, trigger connection analytics on first mount
    useEffect(() => {
        const { clientConnected } = ANALYTICS_EVENTS;
        const { presentationIdKey } = BROWSER_STORAGE_KEYS;
        // Could be null on first client load, but use it if saved (i.e. reconnecting)
        const savedPresentationId = getBrowserStorageItem(presentationIdKey);
        
        connectionAnalytics.mutate(createAnalyticsEventBody(savedPresentationId, clientConnected));
    }, []);

    useEffect(() => {
        const { oneSecond } = PING_INTERVALS;
        const { height, width } = slideRef.current.getBoundingClientRect();

        const refDimensions = { height, width };

        // For now, notify of connection but only send dimensions if we're viewing slides. 
        // We currently only support desktop for PDF 
        if (presentationType === DOCUMENTS_PRESENTATION) {
            refDimensions.height = null;
            refDimensions.width = null;
        }

        setTimeout(async () => {
            await sendDimensions(dispatch, leadId)(refDimensions);
        }, oneSecond);

    }, [presentationType]);
    
    return (
        <ClientView mobile={isMobile}>{children}</ClientView>
    );
};

export default PresentationView;
